//https://github.com/daneden/animate.css
export const animateCSS = (selector, classes, callback) => {
    const node = document.querySelector(selector)
    node.classList.add('animated', ...classes)

    function handleAnimationEnd() {
        node.classList.remove('animated', ...classes)
        node.removeEventListener('animationend', handleAnimationEnd)

        if (typeof callback === 'function') callback()
    }

    node.addEventListener('animationend', handleAnimationEnd)
}
